import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import MetaTags from "../lib/MetaTags";
import Breadcrumbs from "../components/Breadcrumbs";
import { ArticleCard } from "../components/ArticleCard";
import { fetchArticles } from "../lib/api";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const initialQ = params.get("q") || "";
  const [q, setQ] = useState(initialQ);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const run = (query) => {
    setLoading(true);
    fetchArticles(query ? { q: query, limit: 40 } : { limit: 40 })
      .then((d) => {
        setItems(d.items || []);
        setTotal(d.total || 0);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    run(initialQ);
  }, [initialQ]);

  const onSubmit = (e) => {
    e.preventDefault();
    setParams(q ? { q } : {});
  };

  return (
    <Layout>
      <MetaTags title={initialQ ? `Search: ${initialQ}` : "Search"} description="Search across Chicago Electronics Guide." />
      <section className="border-b border-[#121212] bg-white">
        <div className="ceg-container py-10">
          <Breadcrumbs items={[{ to: "/", label: "Home" }, { label: "Search" }]} />
          <p className="ceg-overline mt-6">Search the archive</p>
          <h1 className="font-['Outfit'] font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl lg:text-7xl mt-3 leading-[0.95] break-words">
            {initialQ ? <>Results for<br /><span className="text-[#0055FF]">"{initialQ}"</span></> : "Find a guide"}
          </h1>
          <form onSubmit={onSubmit} className="mt-6 flex items-center border border-[#121212] bg-white max-w-2xl">
            <SearchIcon size={18} className="ml-4 text-[#5C5C5C]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} className="flex-1 bg-transparent px-3 py-3 outline-none" placeholder="iPhone, MacBook, recycling..." data-testid="search-page-input" />
            <button className="bg-[#0055FF] text-white px-5 py-3 font-semibold uppercase tracking-wider text-xs" data-testid="search-page-submit">Search</button>
          </form>
          {initialQ && <p className="mt-3 text-sm text-[#5C5C5C]">{total} {total === 1 ? "result" : "results"}</p>}
        </div>
      </section>

      <section className="ceg-container py-12">
        {loading ? (
          <p className="text-sm text-[#5C5C5C]" data-testid="search-loading">Searching...</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-[#5C5C5C]" data-testid="search-empty">No results. Try a different search term.</p>
        ) : (
          <div className="grid grid-cols-12 gap-6">
            {items.map((a, i) => (
              <div key={a.slug} className="col-span-12 sm:col-span-6 lg:col-span-4">
                <ArticleCard article={a} index={i} />
              </div>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
